import styled from 'styled-components';
import { SimpleGridWrapperProps } from '../types/SearchInputSection.types';

export const SearchHeaderText = styled.div`
  font-family: 'Vodafone';
  font-weight: 700;
  font-size: 20px;
  padding-bottom: 15px;
`;

export const LoadingSpinnerWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 20px;
`;

export const SimpleGridWrapper = styled.div<SimpleGridWrapperProps>`
    [class*='SimpleGridstyle__SimpleGrid-sc'] {
        margin: -10px;

        [class*='SimpleGridstyle__SimpleGridColumn-sc'] {
            padding: 10px;

            [class*='SelectInputWithLabelstyle__Container-sc'] {
                [class*='FieldWrapperstyle__FieldWrapper-sc'] {
                    max-width: unset;
                }
            }

            [class*='SearchInputstyle__SearchInput-sc'] {
                [class*='FieldWrapperstyle__FieldWrapper-sc'] {
                    max-width: unset;

                    [class*='FieldWrapperstyle__InputWrapper-sc'] {
                        [class*='SearchTextInputstyle__SearchWrapper-sc'] {
                            [class*='SearchTextInputstyle__SearchIcon-sc'] {
                                [class*='Interactionstyle__Button-sc'] {
                                    cursor: ${({ searchDisabled }) => (searchDisabled ? "default" : 'pointer')};
                                    background-color: ${({ searchDisabled }) => (searchDisabled ? "#ccc" : undefined)};
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;